import { Button, Modal, Input } from "antd";

const { TextArea } = Input;

const FeedbackModal = ({
  visible,
  feedback,
  onFeedbackChange,
  onSubmit,
  onClose
}) => {
  return (
    <Modal
      title="Feedback"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="submit" type="primary" onClick={onSubmit} className="w-full sm:w-auto">
          Submit
        </Button>,
      ]}
    >
      <p className="mb-4">Please tell us how can we help improve the notes for you.</p>
      <TextArea
        rows={4}
        value={feedback}
        onChange={(e) => onFeedbackChange(e.target.value)}
        placeholder="Enter your feedback here"
        className="w-full"
      />
    </Modal>
  );
};

export default FeedbackModal;